module.exports = __webpack_public_path__ + "static/media/designPatent_30-1040124.bf780011.png";